import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component, EventEmitter, Input,
  OnInit, AfterViewChecked,
  Output, OnDestroy
} from '@angular/core';
import {FileService} from '../../services/file.service';
import {StaticMethods, UploadInfo} from '../../model/GeneralModels';

@Component({
  selector: 'app-file-upload-div',
  template: `
    <div class="upload" *ngIf="!(!fileInfo)">
      <div class="wrap" (clickOutside)="OnClickOutSide($event)" [delayClickOutsideInit]="true">
        <div class="row">
          <div class="col col-12">
            <div class="head">
              <i class="icon ico-cloud-upload-outline"></i>
              <h2>ارسال تصویر
                <mark class="file-name">{{fileInfo.persianName}}</mark>
              </h2>
              <p>لطفا تصویر با کیفیت بارگذاری کنید!</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col col-12">
            <label for="file" class="file" data-file="NationalCard">
              <i class="icon ico-image-outline"></i>
              <span>فایل تصویر خود را انتخاب کنید...</span>
              <div class="mask progress">
                <!--                <mat-progress-spinner></mat-progress-spinner>-->
                <span *ngIf="inProgress">درحال ارسال فایل، صبر کنید...</span>
              </div>
              <input id="file" *ngIf="!inProgress" (change)="callback($event)" name="file" type="file" class="hide"
                     multiple="">
            </label>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: [
    '../../assets/Content/src/css/lib.vendor.css',
    '../../assets/Content/src/css/lib.picker.css',
    '../../assets/Content/src/css/ini.bime.css',
    '../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../assets/css/light.theme.css'
  ]
})
export class FileUploadDivComponent implements OnInit, AfterContentChecked, AfterViewChecked, OnDestroy {
  @Input() productName: string;
  @Input() fileInfo: UploadInfo;
  @Output() ClickOutSide = new EventEmitter<Event>();
  @Output() refresh = new EventEmitter();
  inProgress = false;

  constructor(private cdRef: ChangeDetectorRef,
              private fileService: FileService) {
  }

  ngOnInit() {
  }

  ngAfterViewChecked() {
  }

  ngOnDestroy() {
  }

  callback(event) {
    console.log('fileChanged');
    this.inProgress = true;
    this.fileService.uploadFileWithLinking(this.fileInfo.id, this.productName, event.target.files.item(0),
      this.fileInfo.englishName).subscribe(response => {
      if (response.success) {
        this.inProgress = false;
        this.refresh.emit();
        this.ClickOutSide.emit();
        StaticMethods.showMessage(response.message);
        this.ClickOutSide.emit();
      }
    }, error => {
      if (error) {
        this.inProgress = false;
        console.log(error);
        this.ClickOutSide.emit();
      }
    });
  }

  OnClickOutSide(event: Event) {
    this.ClickOutSide.emit();
  }

  ngAfterContentChecked() {
    this.cdRef.detectChanges();
  }
}
